import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
var TickerListener = /*#__PURE__*/function () {
  function TickerListener(fn) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var priority = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var once = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    _classCallCheck(this, TickerListener);
    this.next = null;
    this.previous = null;
    this._destroyed = false;
    this.fn = fn;
    this.context = context;
    this.priority = priority;
    this.once = once;
  }
  _createClass(TickerListener, [{
    key: "match",
    value: function match(fn) {
      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return this.fn === fn && this.context === context;
    }
  }, {
    key: "emit",
    value: function emit(deltaTime) {
      if (this.fn) {
        if (this.context) {
          this.fn.call(this.context, deltaTime);
        } else {
          this.fn(deltaTime);
        }
      }
      var redirect = this.next;
      if (this.once) {
        this.destroy(true);
      }
      if (this._destroyed) {
        this.next = null;
      }
      return redirect;
    }
  }, {
    key: "connect",
    value: function connect(previous) {
      this.previous = previous;
      if (previous.next) {
        previous.next.previous = this;
      }
      this.next = previous.next;
      previous.next = this;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var hard = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this._destroyed = true;
      this.fn = null;
      this.context = null;
      if (this.previous) {
        this.previous.next = this.next;
      }
      if (this.next) {
        this.next.previous = this.previous;
      }
      var redirect = this.next;
      this.next = hard ? null : redirect;
      this.previous = null;
      return redirect;
    }
  }]);
  return TickerListener;
}();
export { TickerListener };